export default __webpack_public_path__ + "static/staffpass-1-2f18ceb26d379d0fa42c6f7669947d9d.png";